import React, { useEffect, useState } from 'react'
import Header from "./Header"

function ContactUs(data) {
  const [ formData, setFormData ] = useState({
    name: data && data.user && data.user.first_name ? data.user.first_name : '',
    // email: data && data.user && data.user.email ? data.user.email : '',
    ID: data && data.user && data.user._id ? data.user._id : '',
    feedback: ''
  })

  // const [emailError, setEmailError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [unsuccessMessage, setUnsuccessMessage] = useState('')

  const socket = () => {
    if (data && data.socket && data.socket.socket) {
      return data.socket.socket
    } else {
      return null
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  // const handleEmailBlur = (e) => {
  //   const email = e.target.value
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  //   if (!emailRegex.test(email)) {
  //     setEmailError('Invalid email address')
  //   } else {
  //     setEmailError('')
  //   }
  // }

  const handleSubmit = (e) => {
    e.preventDefault()
    // if (emailError) {
    //   alert('Please fix the errors before submitting.')
    //   return
    // }

    const formDataToSend = {
      name: formData.name,
      // email: formData.email,
      feedback: formData.feedback,
      ID: formData.ID
    }

    if (socket()) {
      // console.log(socket().emit)
      socket().emit('sendFeedback', formDataToSend )
    } else {
      setUnsuccessMessage('Failed to send feedback. Try to reload the page and try again');
    }
  };

  useEffect(() => {
    socket().on( 'sendFeedbackResponse', ( status )=>{
      if( status === 'success' ){
        setSuccessMessage('Thank you for your feedback. If a response is required, we will contact you within a few hours');
      }else setUnsuccessMessage('Failed to send feedback. Try to reload the page and try again');
    } )

    return () => {
      socket().off('sendFeedbackResponse')
    }
  }
  ,[ socket() ])

  return (
    <div className="contactUsMainHolder">
      <Header headerContext='privacyPolicy'
      user={data.user}
      logout={data.logout}
      toggleGetChips={data.toggleGetChips}
      width={data.width}
      showSiteMenu = { data.showSiteMenu }
      toggleSiteMenu = { data.toggleSiteMenu }/>
      
      <div className='feedbackContentHolder' >
      <h2 className='feedbackFormTitle'>Tell us your experience playing PokerStream</h2>
      <form className='feedbackForm' onSubmit={handleSubmit}>
        <div className='fieldWrapper'>
          <p>Name</p>
          <input className='input feedbackInput' type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        {/* <div className='fieldWrapper'>
          <p>Email</p>
          <input className='input feedbackInput' type="email" name="email" value={formData.email} onChange={handleChange} onBlur={handleEmailBlur} required />
          { emailError && <p className='errorMessageText'>{ emailError }</p> }
        </div> */}
        <div className='fieldWrapper'>
          <p>Feedback</p>
          <textarea className='input feedbackTextArea' name="feedback" value={formData.feedback} onChange={handleChange} required />
        </div>
        <p className='feedbackFormNote'>Note: PokerStream does not respond to feedback submissions</p>
        <button className='cardButton submitFeedback' type="submit"><p>Send</p></button>
        { successMessage && <p className='successMessageText' >{ successMessage }</p>}
        { unsuccessMessage && <p className='errorMessageText'>{ unsuccessMessage }</p>}
      </form>

      <div className='feedbackEmailHolder'>
        <h4 className='feedbackFormEmailTitle'>If your question is not about feedback,</h4>
        <p className='feedbackFormNote'>please email us: <a className="link" href="mailto:support@pokerstream.app">support@pokerstream.app</a></p>
        <p className='feedbackFormNote'>we typically respond within 24–48 hours</p>
      </div>
      </div>
    </div>
  )
}

export default ContactUs